
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-kompanii",
      function () {
        return require("private-next-pages/o-kompanii.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-kompanii"])
      });
    }
  